<template src= "./index.html"></template>

<script>
import Vue from 'vue'
import isEmpty from 'lodash/isEmpty'
import { parseISO, format } from 'date-fns'
import optionData from '@/optionData/data'



export const BtnDelete = Vue.extend({
  name : 'btnDelete',
  template: `
        <div>
            
            <vs-button style="width:70px;" color="danger" class="btnSmall" @click="btnClickedHandler2()" >삭제</vs-button> 
        </div>
    `,
  data(){
    return{
      title : ''
    }
  },
  created(){
    this.title = this.params.colDef.headerName
  },
  methods: {
    btnClickedHandler() {
      this.params.clicked(this.params.data);
    },
    btnClickedHandler2() {
      this.params.clicked2(this.params.data);
    }
  },
});
export const BtnSelect = Vue.extend({
  name : 'btnSelect',
  template: `
        <div>
            
            <vs-button style="width:70px;" :color="params.data.visible ? 'success' : 'warning'" class="btnSmall" @click="btnClickedHandler()" >{{params.data.visible ? '노출':'비노출'}}</vs-button> 
        </div>
    `,
  data(){
    return{
      title : ''
    }
  },
  created(){
    this.title = this.params.colDef.headerName
  },
  methods: {
    btnClickedHandler() {
      this.params.clicked(this.params.data);
    },
  },
});
export default {
    name: 'genreList',
  
    data () {
        return {
            genreId : null, // 수정용
            genreName : null,
            ddexGenreName : null,
            genreCategory : null,
            
            genreCategortyOption :[
                "팝",
                "팝/재즈/연주곡",
                "랩/힙합",
                'OST',
                '일반가요/포크/발라드',
                '록/팝/포크',
                '아동',
                '기타',
                '발라드',
                '록/포크',
                '종교음악',
                '아동/기타',
                '록',
                '재즈/록',
                '뉴에이지',
                '캐롤',
                '포크',
                '일반가요',
                '일렉트로니카',
                '댄스',
                '크로스오버',
                '알앤비/소울',
                '성인가요',
                '국악',
                '월드',
                '재즈',
                '연주곡',
                '클래식',
                '일반가요'
            ],
            apple: null,
            appleOption : 
                [
                {"label":"Music","value":"MUSIC-00"},
                {"label":"African","value":"AFRICA-00"},
                {"label":"African Dancehall","value":"AFRICAN-DANCEHALL-00"},
                {"label":"African Reggae","value":"AFRICAN-REGGAE-00"},
                {"label":"Afrikaans","value":"AFRIKAANS-00"},
                {"label":"Afro House","value":"AFRO-HOUSE-00"},
                {"label":"Afro Soul","value":"AFRO-SOUL-00"},
                {"label":"Afro-Beat","value":"AFRO-BEAT-00"},
                {"label":"Afro-folk","value":"AFRO-FOLK-00"},
                {"label":"Afro-fusion","value":"AFRO-FUSION-00"},
                {"label":"Afro-Pop","value":"AFRO-POP-00"},
                {"label":"Afrobeats","value":"AFROBEATS-00"},
                {"label":"Alte","value":"ALTE-00"},
                {"label":"Amapiano","value":"AMAPIANO-00"},
                {"label":"Benga","value":"BENGA-00"},
                {"label":"Bongo-Flava","value":"BONGO-FLAVA-00"},
                {"label":"Coupé-Décalé","value":"COUPE-DECALE-00"},
                {"label":"Gqom","value":"GQOM-00"},
                {"label":"Highlife","value":"HIGHLIFE-00"},
                {"label":"Kizomba","value":"KIZOMBA-00"},
                {"label":"Kuduro","value":"KUDURO-00"},
                {"label":"Kwaito","value":"KWAITO-00"},
                {"label":"Maskandi","value":"MASKANDI-00"},
                {"label":"Mbalax","value":"MBALAX-00"},
                {"label":"Ndombolo","value":"NDOMBOLO-00"},
                {"label":"Shangaan Electro","value":"SHANGAAN-ELECTRO-00"},
                {"label":"Soukous","value":"SOUKOUS-00"},
                {"label":"Taarab","value":"TAARAB-00"},
                {"label":"Zouglou","value":"ZOUGLOU-00"},
                {"label":"Alternative","value":"ALTERNATIVE-00"},
                {"label":"Chinese Alt","value":"CHINESE-ALT-00"},
                {"label":"College Rock","value":"COLLEGE-ROCK-00"},
                {"label":"EMO","value":"EMO-00"},
                {"label":"Goth Rock","value":"GOTH-ROCK-00"},
                {"label":"Grunge","value":"GRUNGE-00"},
                {"label":"Indie Egyptian","value":"INDIE-EGYPTIAN-00"},
                {"label":"Indie Levant","value":"INDIE-LEVANT-00"},
                {"label":"Indie Maghreb","value":"INDIE-MAGHREB-00"},
                {"label":"Indie Pop","value":"INDIE-POP-00"},
                {"label":"Indie Rock","value":"INDIE-ROCK-00"},
                {"label":"Korean Indie","value":"KOREAN-INDIE-00"},
                {"label":"New Wave","value":"NEW-WAVE-00"},
                {"label":"Pop Punk","value":"POP-PUNK-00"},
                {"label":"Punk","value":"PUNK-00"},
                {"label":"Turkish Alternative","value":"TURKISH-ALT-00"},
                {"label":"Anime","value":"ANIME-00"},
                {"label":"Arabic","value":"MIDDLE-EAST-00"},
                {"label":"Arabic Pop","value":"ARABIC-POP-00"},
                {"label":"Islamic","value":"ISLAMIC-00"},
                {"label":"Khaleeji","value":"KHALEEJI-00"},
                {"label":"Khaleeji Jalsat","value":"KHALEEJI-JALSAT-00"},
                {"label":"Khaleeji Shailat","value":"KHALEEJI-SHAILAT-00"},
                {"label":"Levant","value":"LEVANT-00"},
                {"label":"Dabke","value":"DABKE-00"},
                {"label":"Maghreb Rai","value":"MAGHREB-RAI-00"},
                {"label":"North African","value":"NORTH-AFRICAN-00"},
                {"label":"Blues","value":"BLUES-00"},
                {"label":"Acoustic Blues","value":"ACOUSTIC-BLUES-00"},
                {"label":"Chicago Blues","value":"CHICAGO-BLUES-00"},
                {"label":"Classic Blues","value":"CLASSIC-BLUES-00"},
                {"label":"Contemporary Blues","value":"CONTEMPORARY-BLUES-00"},
                {"label":"Country Blues","value":"COUNTRY-BLUES-00"},
                {"label":"Delta Blues","value":"DELTA-BLUES-00"},
                {"label":"Electric Blues","value":"ELECTRIC-BLUES-00"},
                {"label":"Brazilian","value":"BRAZILIAN-00"},
                {"label":"Axé","value":"AXE-00"},
                {"label":"Baile Funk","value":"BAILE-FUNK-00"},
                {"label":"Bossa Nova","value":"BOSSA-NOVA-00"},
                {"label":"Choro","value":"CHORO-00"},
                {"label":"Forró","value":"FORRO-00"},
                {"label":"Frevo","value":"FREVO-00"},
                {"label":"MPB","value":"MPB-00"},
                {"label":"Pagode","value":"PAGODE-00"},
                {"label":"Samba","value":"SAMBA-00"},
                {"label":"Sertanejo","value":"SERTANEJO-00"},
                {"label":"Children's Music","value":"CHILDREN-MUSIC-00"},
                {"label":"Lullabies","value":"LULLABIES-00"},
                {"label":"Sing-Along","value":"SING-ALONG-00"},
                {"label":"Stories","value":"STORIES-00"},
                {"label":"Chinese","value":"CHINESE-00"},
                {"label":"Chinese Classical","value":"CHINESE-CLASSICAL-00"},
                {"label":"Chinese Flute","value":"CHINESE-FLUTE-00"},
                {"label":"Chinese Opera","value":"CHINESE-OPERA-00"},
                {"label":"Chinese Orchestral","value":"CHINESE-ORCHESTRAL-00"},
                {"label":"Chinese Regional Folk","value":"CHINESE-REGIONAL-FOLK-00"},
                {"label":"Chinese Strings","value":"CHINESE-STRINGS-00"},
                {"label":"Taiwanese Folk","value":"TAIWANESE-FOLK-00"},
                {"label":"Tibetan Native Music","value":"TIBETAN-NATIVE-MUSIC-00"},
                {"label":"Christian & Gospel","value":"CHRISTIAN-GOSPEL-00"},
                {"label":"CCM","value":"CCM-00"},
                {"label":"Christian Metal","value":"CHRISTIAN-METAL-00"},
                {"label":"Christian Pop","value":"CHRISTIAN-POP-00"},
                {"label":"Christian Rap","value":"CHRISTIAN-RAP-00"},
                {"label":"Christian Rock","value":"CHRISTIAN-ROCK-00"},
                {"label":"Classic Christian","value":"CLASSIC-CHRISTIAN-00"},
                {"label":"Contemporary Gospel","value":"CONTEMPORARY-GOSPEL-00"},
                {"label":"Gospel","value":"GOSPEL-00"},
                {"label":"Praise & Worship","value":"PRAISE-WORSHIP-00"},
                {"label":"Southern Gospel","value":"SOUTHERN-GOSPEL-00"},
                {"label":"Traditional Gospel","value":"TRADITIONAL-GOSPEL-00"},
                {"label":"Classical","value":"CLASSICAL-00"},
                {"label":"Art Song","value":"ART-SONG-00"},
                {"label":"Avant-Garde","value":"AVANT-GARDE-00"},
                {"label":"Baroque Era","value":"BAROQUE-00"},
                {"label":"Brass & Woodwinds","value":"BRASS-WOODWINDS-00"},
                {"label":"Cantata","value":"CANTATA-00"},
                {"label":"Cello","value":"CELLO-00"},
                {"label":"Chamber Music","value":"CHAMBER-MUSIC-00"},
                {"label":"Chant","value":"CHANT-00"},
                {"label":"Choral","value":"CHORAL-00"},
                {"label":"Classical Crossover","value":"CLASSICAL-CROSSOVER-00"},
                {"label":"Classical Era","value":"HIGH-CLASSICAL-00"},
                {"label":"Contemporary Era","value":"CONTEMPORARY-ERA-00"},
                {"label":"Electronic","value":"ELECTRONIC-01"},
                {"label":"Guitar","value":"GUITAR-00"},
                {"label":"Impressionist","value":"IMPRESSIONIST-00"},
                {"label":"Medieval Era","value":"MEDIEVAL-00"},
                {"label":"Minimalism","value":"MINIMALISM-00"},
                {"label":"Modern Era","value":"MODERN-COMPOSITION-00"},
                {"label":"Opera","value":"OPERA-00"},
                {"label":"Oratorio","value":"ORATORIO-00"},
                {"label":"Orchestral","value":"ORCHESTRAL-00"},
                {"label":"Percussion","value":"PERCUSSION-00"},
                {"label":"Piano","value":"PIANO-00"},
                {"label":"Renaissance","value":"RENAISSANCE-00"},
                {"label":"Romantic Era","value":"ROMANTIC-00"},
                {"label":"Sacred","value":"SACRED-00"},
                {"label":"Solo Instrumental","value":"SOLO-INSTRUMENTAL-00"},
                {"label":"Violin","value":"VIOLIN-00"},
                {"label":"Comedy","value":"COMEDY-00"},
                {"label":"Novelty","value":"NOVELTY-00"},
                {"label":"Standup Comedy","value":"STANDUP-COMEDY-00"},
                {"label":"Country","value":"COUNTRY-00"},
                {"label":"Alternative Country","value":"ALTERNATIVE-COUNTRY-00"},
                {"label":"Americana","value":"AMERICANA-00"},
                {"label":"Bluegrass","value":"BLUEGRASS-00"},
                {"label":"Contemporary Bluegrass","value":"CONTEMPORARY-BLUEGRASS-00"},
                {"label":"Contemporary Country","value":"CONTEMPORARY-COUNTRY-00"},
                {"label":"Country Gospel","value":"COUNTRY-GOSPEL-00"},
                {"label":"Honky Tonk","value":"HONKY-TONK-00"},
                {"label":"Outlaw Country","value":"OUTLAW-COUNTRY-00"},
                {"label":"Thai Country","value":"THAI-COUNTRY-00"},
                {"label":"Traditional Bluegrass","value":"TRADITIONAL-BLUEGRASS-00"},
                {"label":"Traditional Country","value":"TRADITIONAL-COUNTRY-00"},
                {"label":"Urban Cowboy","value":"URBAN-COWBOY-00"},
                {"label":"Cuban","value":"CUBAN-00"},
                {"label":"Bolero","value":"BOLERO-00"},
                {"label":"Chachacha","value":"CHACHACHA-00"},
                {"label":"Guajira","value":"GUAJIRA-00"},
                {"label":"Guaracha","value":"GUARACHA-00"},
                {"label":"Mambo","value":"MAMBO-00"},
                {"label":"Son","value":"SON-00"},
                {"label":"Timba","value":"TIMBA-00"},
                {"label":"Dance","value":"DANCE-00"},
                {"label":"Breakbeat","value":"BREAKBEAT-00"},
                {"label":"Garage","value":"GARAGE-00"},
                {"label":"Hardcore","value":"HARDCORE-00"},
                {"label":"House","value":"HOUSE-00"},
                {"label":"Jungle/Drum'n'bass","value":"JUNGLE-DRUM-N-BASS-00"},
                {"label":"Maghreb Dance","value":"MAGHREB-DANCE-00"},
                {"label":"Techno","value":"TECHNO-00"},
                {"label":"Trance","value":"TRANCE-00"},
                {"label":"Disney","value":"DISNEY-00"},
                {"label":"Easy Listening","value":"EASY-LISTENING-00"},
                {"label":"Lounge","value":"LOUNGE-00"},
                {"label":"Swing","value":"SWING-00"},
                {"label":"Electronic","value":"ELECTRONIC-00"},
                {"label":"Ambient","value":"AMBIENT-00"},
                {"label":"Bass","value":"BASS-00"},
                {"label":"Downtempo","value":"DOWNTEMPO-00"},
                {"label":"Dubstep","value":"DUBSTEP-00"},
                {"label":"Electro-Cha'abi","value":"ELECTRO-CHAABI-00"},
                {"label":"Electronica","value":"ELECTRONICA-00"},
                {"label":"IDM/Experimental","value":"IDM-EXPERIMENTAL-00"},
                {"label":"Industrial","value":"INDUSTRIAL-00"},
                {"label":"Levant Electronic","value":"LEVANT-ELECTRONIC-00"},
                {"label":"Maghreb Electronic","value":"MAGHREB-ELECTRONIC-00"},
                {"label":"Enka","value":"ENKA-00"},
                {"label":"Fitness & Workout","value":"FITNESS-WORKOUT-00"},
                {"label":"Folk","value":"FOLK-00"},
                {"label":"Iraqi Folk","value":"IRAQI-FOLK-00"},
                {"label":"Khaleeji Folk","value":"KHALEEJI-FOLK-00"},
                {"label":"French Pop","value":"FRENCH-POP-00"},
                {"label":"German Folk","value":"GERMAN-FOLK-00"},
                {"label":"German Pop","value":"GERMAN-POP-00"},
                {"label":"Hip Hop/Rap","value":"HIP-HOP-RAP-00"},
                {"label":"Alternative Rap","value":"ALTERNATIVE-RAP-00"},
                {"label":"Chinese Hip-Hop","value":"CHINESE-HIP-HOP-00"},
                {"label":"Dirty South","value":"DIRTY-SOUTH-00"},
                {"label":"East Coast Rap","value":"EAST-COAST-RAP-00"},
                {"label":"Egyptian Hip-Hop","value":"EGYPTIAN-HIP-HOP-00"},
                {"label":"Gangsta Rap","value":"GANGSTA-RAP-00"},
                {"label":"Hardcore Rap","value":"HARDCORE-RAP-00"},
                {"label":"Hip-Hop","value":"HIP-HOP-00"},
                {"label":"Khaleeji Hip-Hop","value":"KHALEEJI-HIP-HOP-00"},
                {"label":"Korean Hip-Hop","value":"KOREAN-HIP-HOP-00"},
                {"label":"Latin Rap","value":"LATIN-RAP-00"},
                {"label":"Levant Hip-Hop","value":"LEVANT-HIP-HOP-00"},
                {"label":"Maghreb Hip-Hop","value":"MAGHREB-HIP-HOP-00"},
                {"label":"Old School Rap","value":"OLD-SCHOOL-RAP-00"},
                {"label":"Rap","value":"RAP-00"},
                {"label":"Russian Hip-Hop","value":"RUSSIAN-HIP-HOP-00"},
                {"label":"Turkish Hip-Hop/Rap","value":"TURKISH-HIP-HOP-00"},
                {"label":"UK Hip Hop","value":"UK-HIP-HOP-00"},
                {"label":"Underground Rap","value":"UNDERGROUND-RAP-00"},
                {"label":"West Coast Rap","value":"WEST-COAST-RAP-00"},
                {"label":"Holiday","value":"HOLIDAY-00"},
                {"label":"Chanukah","value":"CHANUKAH-00"},
                {"label":"Christmas","value":"CHRISTMAS-00"},
                {"label":"Christmas: Children's","value":"CHRISTMAS-CHILDRENS-00"},
                {"label":"Christmas: Classic","value":"CHRISTMAS-CLASSIC-00"},
                {"label":"Christmas: Classical","value":"CHRISTMAS-CLASSICAL-00"},
                {"label":"Christmas: Country","value":"CHRISTMAS-COUNTRY-00"},
                {"label":"Christmas: Jazz","value":"CHRISTMAS-JAZZ-00"},
                {"label":"Christmas: Modern","value":"CHRISTMAS-MODERN-00"},
                {"label":"Christmas: Pop","value":"CHRISTMAS-POP-00"},
                {"label":"Christmas: R&B","value":"CHRISTMAS-R-B-00"},
                {"label":"Christmas: Religious","value":"CHRISTMAS-RELIGIOUS-00"},
                {"label":"Christmas: Rock","value":"CHRISTMAS-ROCK-00"},
                {"label":"Easter","value":"EASTER-00"},
                {"label":"Halloween","value":"HALLOWEEN-00"},
                {"label":"Thanksgiving","value":"THANKSGIVING-00"},
                {"label":"Hörspiele","value":"HORSPIELE-00"},
                {"label":"Indian","value":"INDIAN-00"},
                {"label":"Bollywood","value":"BOLLYWOOD-00"},
                {"label":"Devotional & Spiritual","value":"DEVOTIONAL-SPIRITUAL-00"},
                {"label":"Ghazals","value":"GHAZALS-00"},
                {"label":"Indian Classical","value":"INDIAN-CLASSICAL-00"},
                {"label":"Carnatic Classical","value":"CARNATIC-CLASSICAL-00"},
                {"label":"Hindustani Classical","value":"HINDUSTANI-CLASSICAL-00"},
                {"label":"Indian Folk","value":"INDIAN-FOLK-00"},
                {"label":"Indian Pop","value":"INDIAN-POP-00"},
                {"label":"Regional Indian","value":"REGIONAL-INDIAN-00"},
                {"label":"Assamese","value":"ASSAMESE-00"},
                {"label":"Bengali","value":"BENGALI-00"},
                {"label":"Rabindra Sangeet","value":"RABINDRA-SANGEET-00"},
                {"label":"Bhojpuri","value":"BHOJPURI-00"},
                {"label":"Gujarati","value":"GUJARATI-00"},
                {"label":"Haryanvi","value":"HARYANVI-00"},
                {"label":"Kannada","value":"KANNADA-00"},
                {"label":"Malayalam","value":"MALAYALAM-00"},
                {"label":"Marathi","value":"MARATHI-00"},
                {"label":"Odia","value":"ODIA-00"},
                {"label":"Punjabi","value":"PUNJABI-00"},
                {"label":"Punjabi Pop","value":"PUNJABI-POP-00"},
                {"label":"Rajasthani","value":"RAJASTHANI-00"},
                {"label":"Tamil","value":"TAMIL-00"},
                {"label":"Telugu","value":"TELUGU-00"},
                {"label":"Urdu","value":"URDU-00"},
                {"label":"Sufi","value":"SUFI-AND-GHAZALS-00"},
                {"label":"Inspirational","value":"INSPIRATIONAL-00"},
                {"label":"Instrumental","value":"INSTRUMENTAL-00"},
                {"label":"J-Pop","value":"J-POP-00"},
                {"label":"Jazz","value":"JAZZ-00"},
                {"label":"Avant-Garde Jazz","value":"AVANT-GARDE-JAZZ-00"},
                {"label":"Bebop","value":"BOP-00"},
                {"label":"Bebop","value":"BEBOP-00"},
                {"label":"Big Band","value":"BIG-BAND-00"},
                {"label":"Contemporary Jazz","value":"CONTEMPORARY-JAZZ-00"},
                {"label":"Cool Jazz","value":"COOL-00"},
                {"label":"Crossover Jazz","value":"CROSSOVER-JAZZ-00"},
                {"label":"Dixieland","value":"DIXIELAND-00"},
                {"label":"Fusion","value":"FUSION-00"},
                {"label":"Hard Bop","value":"HARD-BOP-00"},
                {"label":"Latin Jazz","value":"LATIN-JAZZ-00"},
                {"label":"Mainstream Jazz","value":"MAINSTREAM-JAZZ-00"},
                {"label":"Ragtime","value":"RAGTIME-00"},
                {"label":"Smooth Jazz","value":"SMOOTH-JAZZ-00"},
                {"label":"Trad Jazz","value":"TRAD-JAZZ-00"},
                {"label":"Vocal Jazz","value":"VOCAL-JAZZ-00"},
                {"label":"Karaoke","value":"KARAOKE-00"},
                {"label":"Kayokyoku","value":"KAYOKYOKU-00"},
                {"label":"Korean","value":"KOREAN-00"},
                {"label":"Korean Traditional","value":"KOREAN-CLASSICAL-00"},
                {"label":"Latin","value":"LATIN-00"},
                {"label":"Alternative & Rock in Spanish","value":"ALTERNATIVO-ROCK-LATINO-00"},
                {"label":"Baladas y Boleros","value":"BALADAS-Y-BOLEROS-00"},
                {"label":"Contemporary Latin","value":"CONTEMPORARY-LATIN-00"},
                {"label":"Latin Jazz","value":"LATIN-JAZZ-01"},
                {"label":"Latin Urban","value":"REGGAETON-Y-HIP-HOP-00"},
                {"label":"Pop in Spanish","value":"POP-LATINO-00"},
                {"label":"Raices","value":"RAICES-00"},
                {"label":"Regional Mexicano","value":"REGIONAL-MEXICANO-00"},
                {"label":"Salsa y Tropical","value":"SALSA-Y-TROPICAL-00"},
                {"label":"Marching Bands","value":"MARCHING-BANDS-00"},
                {"label":"New Age","value":"NEW-AGE-00"},
                {"label":"Healing","value":"HEALING-00"},
                {"label":"Meditation","value":"MEDITATION-00"},
                {"label":"Nature","value":"NATURE-00"},
                {"label":"Relaxation","value":"RELAXATION-00"},
                {"label":"Travel","value":"TRAVEL-00"},
                {"label":"Yoga","value":"YOGA-00"},
                {"label":"Pop","value":"POP-00"},
                {"label":"Adult Contemporary","value":"ADULT-CONTEMPORARY-00"},
                {"label":"Britpop","value":"BRITPOP-00"},
                {"label":"Cantopop","value":"CANTOPOP-HK-POP-00"},
                {"label":"Egyptian Pop","value":"EGYPTIAN-POP-00"},
                {"label":"Indo Pop","value":"INDO-POP-00"},
                {"label":"Iraqi Pop","value":"IRAQI-POP-00"},
                {"label":"K-Pop","value":"K-POP-00"},
                {"label":"Khaleeji Pop","value":"KHALEEJI-POP-00"},
                {"label":"Korean Folk-Pop","value":"KOREAN-FOLK-POP-00"},
                {"label":"Levant Pop","value":"LEVANT-POP-00"},
                {"label":"Maghreb Pop","value":"MAGHREB-POP-00"},
                {"label":"Malaysian Pop","value":"MALAYSIAN-POP-00"},
                {"label":"Mandopop","value":"MANDOPOP-00"},
                {"label":"Manilla Sound","value":"MANILLA-SOUND-00"},
                {"label":"Oldies","value":"OLDIES-00"},
                {"label":"Original Pilipino Music","value":"ORIGINAL-PILIPINO-MUSIC-00"},
                {"label":"Pinoy Pop","value":"PINOY-POP-00"},
                {"label":"Pop/Rock","value":"POP-ROCK-00"},
                {"label":"Russian Pop","value":"RUSSIAN-POP-00"},
                {"label":"Shows","value":"SHOWS-00"},
                {"label":"Soft Rock","value":"SOFT-ROCK-00"},
                {"label":"Tai-Pop","value":"TAI-POP-00"},
                {"label":"Teen Pop","value":"TEEN-POP-00"},
                {"label":"Thai Pop","value":"THAI-POP-00"},
                {"label":"Turkish Pop","value":"TURKISH-POP-00"},
                {"label":"R&B/Soul","value":"R-B-SOUL-00"},
                {"label":"Contemporary R&B","value":"CONTEMPORARY-R-B-00"},
                {"label":"Disco","value":"DISCO-00"},
                {"label":"Doo Wop","value":"DOO-WOP-00"},
                {"label":"Funk","value":"FUNK-00"},
                {"label":"Motown","value":"MOTOWN-00"},
                {"label":"Neo-Soul","value":"NEO-SOUL-00"},
                {"label":"Soul","value":"SOUL-00"},
                {"label":"Reggae","value":"REGGAE-00"},
                {"label":"Dub","value":"DUB-00"},
                {"label":"Lovers Rock","value":"LOVERS-ROCK-00"},
                {"label":"Modern Dancehall","value":"DANCEHALL-00"},
                {"label":"Roots Reggae","value":"ROOTS-REGGAE-00"},
                {"label":"Ska","value":"SKA-00"},
                {"label":"Rock","value":"ROCK-00"},
                {"label":"Adult Alternative","value":"ADULT-ALTERNATIVE-00"},
                {"label":"American Trad Rock","value":"AMERICAN-TRAD-ROCK-00"},
                {"label":"Arena Rock","value":"ARENA-ROCK-00"},
                {"label":"Blues-Rock","value":"BLUES-ROCK-00"},
                {"label":"British Invasion","value":"BRITISH-INVASION-00"},
                {"label":"Chinese Rock","value":"CHINESE-ROCK-00"},
                {"label":"Death Metal/Black Metal","value":"DEATH-METAL-BLACK-METAL-00"},
                {"label":"Glam Rock","value":"GLAM-ROCK-00"},
                {"label":"Hair Metal","value":"HAIR-METAL-00"},
                {"label":"Hard Rock","value":"HARD-ROCK-00"},
                {"label":"Heavy Metal","value":"HEAVY-METAL-00"},
                {"label":"Jam Bands","value":"JAM-BANDS-00"},
                {"label":"Korean Rock","value":"KOREAN-ROCK-00"},
                {"label":"Prog-Rock/Art Rock","value":"PROG-ROCK-ART-ROCK-00"},
                {"label":"Psychedelic","value":"PSYCHEDELIC-00"},
                {"label":"Rock & Roll","value":"ROCK-ROLL-00"},
                {"label":"Rockabilly","value":"ROCKABILLY-00"},
                {"label":"Roots Rock","value":"ROOTS-ROCK-00"},
                {"label":"Russian Rock","value":"RUSSIAN-ROCK-00"},
                {"label":"Singer/Songwriter","value":"SINGER-SONGWRITER-01"},
                {"label":"Southern Rock","value":"SOUTHERN-ROCK-00"},
                {"label":"Surf","value":"SURF-00"},
                {"label":"Tex-Mex","value":"TEX-MEX-00"},
                {"label":"Turkish Rock","value":"TURKISH-ROCK-00"},
                {"label":"Russian","value":"RUSSIAN-00"},
                {"label":"Russian Bard","value":"RUSSIAN-BARD-00"},
                {"label":"Russian Chanson","value":"RUSSIAN-CHANSON-00"},
                {"label":"Russian Romance","value":"RUSSIAN-ROMANCE-00"},
                {"label":"Singer/Songwriter","value":"SINGER-SONGWRITER-00"},
                {"label":"Alternative Folk","value":"ALTERNATIVE-FOLK-00"},
                {"label":"Contemporary Folk","value":"CONTEMPORARY-FOLK-00"},
                {"label":"Contemporary Singer/Songwriter","value":"CONTEMPORARY-SINGER-SONGWRITER-00"},
                {"label":"Folk-Rock","value":"FOLK-ROCK-00"},
                {"label":"New Acoustic","value":"NEW-ACOUSTIC-00"},
                {"label":"Traditional Folk","value":"TRADITIONAL-FOLK-00"},
                {"label":"Soundtrack","value":"SOUNDTRACK-00"},
                {"label":"Foreign Cinema","value":"FOREIGN-CINEMA-00"},
                {"label":"Musicals","value":"MUSICALS-00"},
                {"label":"Original Score","value":"ORIGINAL-SCORE-00"},
                {"label":"Sound Effects","value":"SOUND-EFFECT-00"},
                {"label":"Soundtrack","value":"FILM-SOUNDTRACK-00"},
                {"label":"TV Soundtrack","value":"TV-SOUNDTRACK-00"},
                {"label":"Video Game","value":"VIDEOGAME-00"},
                {"label":"Spoken Word","value":"SPOKEN-WORD-00"},
                {"label":"Tarab","value":"TARAB-00"},
                {"label":"Egyptian Tarab","value":"EGYPTIAN-TARAB-00"},
                {"label":"Iraqi Tarab","value":"IRAQI-TARAB-00"},
                {"label":"Khaleeji Tarab","value":"KHALEEJI-TARAB-00"},
                {"label":"Turkish","value":"TURKISH-00"},
                {"label":"Arabesk","value":"ARABESQUE-00"},
                {"label":"Fantezi","value":"FANTEZI-00"},
                {"label":"Halk","value":"HALK-00"},
                {"label":"Religious","value":"RELIGIOUS-00"},
                {"label":"Sanat","value":"SANAT-00"},
                {"label":"Özgün","value":"OZGUN-00"},
                {"label":"Vocal","value":"VOCAL-00"},
                {"label":"Standards","value":"STANDARDS-00"},
                {"label":"Traditional Pop","value":"TRADITIONAL-POP-00"},
                {"label":"Trot","value":"TROT-00"},
                {"label":"Vocal Pop","value":"VOCAL-POP-00"},
                {"label":"Worldwide","value":"WORLD-00"},
                {"label":"Asia","value":"ASIA-00"},
                {"label":"Australia","value":"AUSTRALIA-00"},
                {"label":"Cajun","value":"CAJUN-00"},
                {"label":"Calypso","value":"CALYPSO-00"},
                {"label":"Caribbean","value":"CARIBBEAN-00"},
                {"label":"Celtic","value":"CELTIC-00"},
                {"label":"Celtic Folk","value":"CELTIC-FOLK-00"},
                {"label":"Contemporary Celtic","value":"CONTEMPORARY-CELTIC-00"},
                {"label":"Dangdut","value":"DANGDUT-00"},
                {"label":"Dini","value":"DINI-00"},
                {"label":"Europe","value":"EUROPE-00"},
                {"label":"Fado","value":"FADO-00"},
                {"label":"Farsi","value":"FARSI-00"},
                {"label":"Flamenco","value":"FLAMENCO-00"},
                {"label":"France","value":"FRANCE-00"},
                {"label":"Hawaii","value":"HAWAII-00"},
                {"label":"Iberia","value":"IBERIA-00"},
                {"label":"Indonesian Religious","value":"INDONESIAN-RELIGIOUS-00"},
                {"label":"Israeli","value":"ISRAELI-00"},
                {"label":"Japan","value":"JAPAN-00"},
                {"label":"Klezmer","value":"KLEZMER-00"},
                {"label":"North America","value":"NORTH-AMERICA-00"},
                {"label":"Polka","value":"POLKA-00"},
                {"label":"Soca","value":"SOCA-00"},
                {"label":"South Africa","value":"SOUTH-AFRICA-00"},
                {"label":"South America","value":"SOUTH-AMERICA-00"},
                {"label":"Tango","value":"TANGO-00"},
                {"label":"Traditional Celtic","value":"TRADITIONAL-CELTIC-00"},
                {"label":"Worldbeat","value":"WORLDBEAT-00"},
                {"label":"Zydeco","value":"ZYDECO-00"}
            ],
            fuga : null,
            fugaOption : [
                "Alternative",
                "Audiobooks",
                "Blues",
                "Children's Music",
                "Classical",
                "Comedy",
                "Country",
                "Dance",
                "Electronic",
                "Folk",
                "Hip Hop/Rap",
                "Holiday",
                "Inspirational",
                "Jazz",
                "Latin",
                "New Age",
                "Opera",
                "Pop",
                "Rock",
                "R&B/Soul",
                "Reggae",
                "Soundtrack",
                "Spoken Word",
                "Vocal",
                "World",
            ],
            audiblemagic : null,
            audiblemagicOption: [
                "Alternative/Indie",
                "Blues",
                "Cast Recordings/Cabaret",
                "Children's",
                "Christian/Gospel",
                "Classical/Opera",
                "Comedy/Spoken Word",
                "Country",
                "Electronica/Dance",
                "Folk",
                "Instrumental",
                "Jazz",
                "Latin",
                "New Age",
                "Pop",
                "Rap/Hip Hop",
                "Reggae/Ska",
                "Rock",
                "Seasonal",
                "Soul/R&B",
                "Soundtracks",
                "Vocals",
                "World",
            ],
            optionData : optionData,
            
            roleType : null,
            entity: '사업자개인',

            keywordOption :optionData.artistKeyword,
            keywordType :'display_name',
            keyword : '',
            total : 0,
            page: {
                pageSize : 50,
                currentPage: 1,                       // 현재 페이지
                totalPage: 0,                         // 총 페이지수
            },          
            gridOptions :{ // 테이플 옵션
                context: {
                    componentParent: this
                },
                onRowClicked: (event)=>{
                    //this.viewDetail(event)
                },
                frameworkComponents : {
                    btnDelete : BtnDelete,
                    btnSelect : BtnSelect
                }
            },
            defaultColDef: {
                sortable: false,
                editable: false,
                resizable: true,
                suppressMenu: false,
                rowSelection:'single'
            },
            columnDefs: [
                {headerName: '장르명',  field: 'name_english',  filter: false,width: 450},
                {headerName: 'MIMS 카테고리',    field: 'category',   filter: false,width: 250},
               
                {headerName: 'DDEX 장르',    field: 'ddex',   filter: false,width: 200},
                {headerName: '등록일',      field: 'created_at',     filter: false,width: 200,
                cellRenderer: (data) => {
                return this.fixDate(data.value, 'yyyy-MM-dd HH:mm:ss')
                }},
                {headerName: '', field: 'id', filter: false,width: 110,
                    cellRendererParams: {
                        clicked: function(data) {
                            this.context.componentParent.genreVisible(data);
                        },
                    },
                    cellRenderer: 'btnSelect'
                },
                {headerName: '', field: 'id', filter: false,minWidth: 140,
                    cellRendererParams: {
                        clicked: function(data) {
                            this.context.componentParent.genreEdit(data.id);
                        },
                        clicked2 : function(data) {
                            
                            this.context.componentParent.genreDelete(data.id);
                        }
                    },
                    cellRenderer: 'btnDelete'
                },
            ],
            tableData:[
            ],
            testMessage: "최고당!",
            genreTable : {
                column : [
                    { label:'노출여부', field: 'visible', width: 110,},
                    {label: '수정',  field: 'id', filter: false, maxWidth: '500px'},
                    {label: '장르명',  field: 'name_english', filter: false, maxWidth: '500px'},
                    {label: 'Apple 장르',  field: 'apple', filter: false, formatFn: (data) => {
                        let text = ''
                        this.appleOption.map((option)=>{
                            if( option.value == data){
                                text =  option.label
                            }
                        })
                        return text
                    }},
                    {label: 'Fuga 장르',    field: 'fuga', filter: false,width: 250},
                    {label: 'MIMS 카테고리',    field: 'category', filter: false,width: 250},
                    {label: 'DDEX 장르',    field: 'ddex',   filter: false,width: 200},
                    {label: 'Audible Magic 장르',    field: 'audiblemagic',   filter: false,width: 200},
                    {label: '등록일', field: 'created_at', filter: false,minWidth: 140,width:140 , formatFn: (data) => {
                        return this.fixDate(data, 'yyyy-MM-dd')
                    }},
                   
                ]
            }
        }
    },
    created(){
        if(this.$route.query.page){
            this.page.currentPage= Number(this.$route.query.page)
        }
        if(this.$route.query.keywordType){
            this.keywordType= this.$route.query.keywordType
        }
        if(this.$route.query.keyword){
            this.keyword= this.$route.query.keyword
        }
        
    },
    mounted(){
        this.$nextTick(() =>{
        this.callList()
        })
    },
    computed: {
    
    },
    watch: {
        'page.currentPage'(e){
            
            this.callList()
        },
        'page.pageSize'(){
            this.list_search()
        }
    },
    methods: {
        callList(){
            const option = {
                sort: 'created_at',
                sortorder: 'desc',
                page: this.page.currentPage-1 ,
                limit: this.page.pageSize,
                //is_various_artists: false, // 필수 filter
            }
            
            let query = {}

            if(this.page.currentPage != 1){
                query['page'] = this.page.currentPage
            }
            if(this.keywordType && !this.valCheck(this.keyword) ) {
                option[this.keywordType] = this.keyword
                query['keywordType'] = this.keywordType
                query['keyword'] = this.keyword
            }   
            this.$router.replace({query: query}).catch((e)=>{});
            
            this.loadingShow()

            this.$store.dispatch('GET_GENRE', option)
            .then(result =>{
                this.loadingHide()
                this.tableData  = result.items // 권리자 목록
                
                this.total = result.total // 총인원수 
                this.filtered = result.filtered // limit에 따른 수
                //페이지 수
                const remainder = parseInt(this.filtered % this.page.pageSize) > 0? 1: 0
                this.page.totalPage = parseInt(this.filtered/this.page.pageSize) + remainder
            }).catch(error=>{
                const status = error.response.status
                this.loadingHide()
                switch(status){
                    
                    case 401:
                    this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
                    break;
                    default:
                        this.alert({msg : error.response.data.message})
                    break;
                }
            })
        },
        
        list_search(){
        this.page.currentPage = 1  // 초기화
        this.callList()
        },

        genreVisible(data){
            let payload = {
                id : data.id,
                params : {
                    "visible": !data.visible,
                }
            }
            console.log(payload)
            this.confirm({
                title : '장르삭제 확인',
                msg : `
                    선택하신 장르 상태를 ${!data.visible ? '노출' : '비노출'}로 변경하시겠습니까?
                `,
                autofocus : true,
                width:400,
                action : ()=>{
                    this.loadingShow()
                    this.$store.dispatch('PUT_GENRE', payload)
                    .then(result =>{
                        this.closeModal('confirm')
                        this.loadingHide()
                        this.callList()
                    }).catch(error=>{
                        const status = error.response.status
                        this.loadingHide()
                        switch(status){
                            case 401:
                            this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
                            break;
                            default:
                                this.alert({msg : error.response.data.message})
                            break;
                        }
                    })
                }
            })
        },
        genreEdit(data){
            this.genreId = data.id 
            this.genreName = data.name_english; 
            this.genreCategory = data.category;
            this.ddexGenreName = data.ddex;
            this.apple = data.apple;
            this.fuga = data.fuga
            this.audiblemagic = data.audiblemagic
            this.openModal('genreEdit')
        },
        genreSave(){
            let payload ={
                "id" : this.genreId,
                params : {
                    "name_english": this.genreName,
                    "name_korean": '',
                    "ddex" : this.ddexGenreName,
                    "category": this.genreCategory,
                    'apple' : this.apple,
                    'fuga':this.fuga,
                    'audiblemagic':this.audiblemagic
                }
                
            }
            if(this.valCheck(this.genreName) && this.valCheck(this.genreCategory) && this.valCheck(this.ddexGenreName) ){
                this.alert({msg : '카테고리와 이름을 확인해주세요.'})
                return false
            }
            this.loadingShow()
            this.$store.dispatch('PUT_GENRE', payload)
            .then(result =>{
                this.closeModal('genreEdit')
                this.callList()
            }).catch(error=>{
                const status = error.response.status
                this.loadingHide()
                switch(status){
                    case 401:
                    this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
                    break;
                    default:
                        this.alert({msg : error.response.data.message})
                    break;
                }
            })
        },
        genreDelete(id){
            this.confirm({
                title : '장르삭제 확인',
                msg : `
                    선택하신 장르를 삭제하시겠습니까?
                `,
                autofocus : true,
                width:400,
                action : ()=>{
                    this.loadingShow()
                    this.$store.dispatch('DELETE_GENRE', {id:id})
                    .then(result =>{
                        this.closeModal('confirm')
                        this.loadingHide()
                        this.callList()
                    }).catch(error=>{
                        const status = error.response.status
                        this.loadingHide()
                        switch(status){
                            case 401:
                            this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
                            break;
                            default:
                                this.alert({msg : error.response.data.message})
                            break;
                        }
                    })
                }
            })
        },
        genrePost(event){
            let payload ={
                "name_english": this.genreName,
                "name_korean": '',
                "ddex" : this.ddexGenreName,
                "category": this.genreCategory,
                'apple' : this.apple,
                'fuga':this.fuga,
                'audiblemagic':this.audiblemagic
            }
            if(this.valCheck(this.genreName) && this.valCheck(this.genreCategory) && this.valCheck(this.ddexGenreName) ){
                this.alert({msg : '카테고리와 이름을 확인해주세요.'})
                return false
            }
            this.loadingShow()
            this.$store.dispatch('POST_GENRE', payload)
            .then(result =>{
                this.closeModal('genre')
                this.loadingHide()
                this.callList()
            }).catch(error=>{
                const status = error.response.status
                this.loadingHide()
                switch(status){
                    case 401:
                    this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
                    break;
                    default:
                        this.alert({msg : error.response.data.message})
                    break;
                }
            })
        }
    }
}
</script>

<style scoped>

</style>
